import { formatInTimeZone } from "date-fns-tz";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import DateRangeComp from "../../common/DateRangeComp";
import * as actions from "../redux/RefundNPromotionAction";
import { MemberRefundHistoryDetail } from "./MemberRefundHistoryDetail";

export const MemberRefundHistory = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [refundid, setRefundid] = useState();

  const refundNPromotionState = useSelector(
    ({ refundNPromotion }) => refundNPromotion,
    shallowEqual
  );
  const timeZone = "Asia/Kuala_Lumpur";

  useEffect(() => {
    const timeZone = "Asia/Kuala_Lumpur";
    const queryParams = {
      action: "refundhistory",
      fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
      todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
    };
    dispatch(actions.memberRefundHistory(queryParams));
  }, [dispatch]);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };

  const handleSearchClick = () => {
    const queryParams = {
      action: "refundhistory",
      fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
      todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
    };
    dispatch(actions.memberRefundHistory(queryParams)).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <div style={{ width: "98%", margin: "5px auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <MemberRefundHistoryDetail
        setRefundid={setRefundid}
        refundid={refundid}
        setSwalProps={setSwalProps}
      />
      <div>
        <h2>{intl.formatMessage({ id: "memberRefundHistory" })}</h2>
      </div>
      <div className="dateSearch-div">
        <div className="dateRange-div">
          <DateRangeComp
            initialRange={[
              { startDate: fromDate, endDate: toDate, key: "selection" },
            ]}
            onDateChange={handleDateChange}
          />
        </div>
        <div>
          <button
            className="btn btn-primary"
            onClick={() => handleSearchClick()}
          >
            {intl.formatMessage({ id: "search" })}
          </button>
        </div>
      </div>
      <div
        className="member-div d-flex"
        style={{
          margin: "10px auto",
        }}
      >
        <div className="member-container">
          <div className="table-responsive">
            <table className="member-table">
              <thead className="member-header1">
                <tr className="member-row1">
                  <th className="member-cell hide-on-mobile">
                    {intl.formatMessage({ id: "no" })}
                  </th>
                  <th className="member-cell text-start text-nowrap">
                    {intl.formatMessage({ id: "refundBy" })}
                  </th>
                  <th className="member-cell text-start text-nowrap">
                    {intl.formatMessage({ id: "member" })}
                  </th>
                  <th className="member-cell text-nowrap">
                    {intl.formatMessage({ id: "date" })}
                  </th>
                  <th className="member-cell text-nowrap text-start">
                    {intl.formatMessage({ id: "baseOn" })}
                  </th>
                  <th className="member-cell text-nowrap text-start">
                    {intl.formatMessage({ id: "level" })}
                  </th>
                  <th className="member-cell text-nowrap text-start">
                    {intl.formatMessage({ id: "direction" })}
                  </th>
                  <th className="member-cell text-nowrap text-end">
                    {intl.formatMessage({ id: "directionNum" })}
                  </th>
                  <th className="member-cell text-nowrap text-start">
                    {intl.formatMessage({ id: "refundType" })}
                  </th>
                  <th className="member-cell text-nowrap text-end">
                    {intl.formatMessage({ id: "refundNumber" })}
                  </th>
                  <th className="member-cell text-nowrap text-end">
                    {intl.formatMessage({ id: "refundBalance" })}
                  </th>
                  <th className="member-cell text-nowrap">
                    {intl.formatMessage({ id: "fromDate" })}
                  </th>
                  <th className="member-cell text-nowrap">
                    {intl.formatMessage({ id: "toDate" })}
                  </th>
                  <th className="member-cell text-nowrap">
                    {intl.formatMessage({ id: "action" })}
                  </th>
                </tr>
              </thead>
              <tbody className="member-body">
                {refundNPromotionState.memberRefundHistory?.refundHistorys &&
                refundNPromotionState.memberRefundHistory.refundHistorys
                  .length > 0 ? (
                  refundNPromotionState.memberRefundHistory.refundHistorys.map(
                    (report, index) => (
                      <tr key={index} className="member-row1">
                        <td className="member-cell hide-on-mobile">
                          {index + 1}
                        </td>
                        <td className="member-cell text-start">
                          {report.refundby}
                        </td>
                        <td className="member-cell text-end">
                          {report.membercount}
                        </td>
                        <td className="member-cell ">{report.refunddate}</td>
                        <td className="member-cell text-start">
                          {report.directionbaseon}
                        </td>
                        <td className="member-cell text-start">
                          {report.level}
                        </td>
                        <td className="member-cell text-start">
                          {report.direction}
                        </td>
                        <td className="member-cell text-end">
                          {report.directionnum}
                        </td>
                        <td className="member-cell text-start">
                          {report.refundtype}
                        </td>
                        <td className="member-cell text-end">
                          {report.refundnumber}
                        </td>
                        <td className="member-cell text-end">
                          {report.refundbalance}
                        </td>
                        <td className="member-cell">{report.fromdate}</td>
                        <td className="member-cell">{report.todate}</td>
                        <td className="member-cell">
                          <button
                            className="btn btn-primary me-1"
                            style={{
                              backgroundColor: "#00FFFF",
                              borderColor: "#00FFFF",
                              color: "black",
                            }}
                            onClick={() => {
                              setRefundid(report.refundid);
                            }}
                          >
                            <i className="bi bi-exclamation-circle" />
                          </button>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan="13">
                      <div className="no-record-wrapper oRecordDiv">
                        <i className="bi bi-search fs-1 mb-3" />
                        <div className="text-font2">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                {refundNPromotionState &&
                  refundNPromotionState.memberRefundHistory && (
                    <tr
                      className="member-row1"
                      style={{
                        borderTop: "1px solid rgba(175, 164, 164, 0.4)",
                      }}
                    >
                      <td className="member-cell hide-on-mobile"></td>
                      <td className="member-cell text-end"></td>
                      <td className="member-cell text-end"></td>
                      <td className="member-cell text-end"></td>
                      <td className="member-cell text-end"></td>
                      <td className="member-cell text-end"></td>
                      <td className="member-cell text-end"></td>
                      <td className="member-cell text-end"></td>
                      <td className="member-cell text-end"></td>
                      <td className="member-cell text-end">
                        {intl.formatMessage({ id: "total" }) + " : "}
                      </td>
                      <td className="member-cell text-end">
                        {refundNPromotionState.memberRefundHistory.totalrefund}
                      </td>
                    </tr>
                  )}
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
